import { useLang } from "../context/LanguageContext";
import { LANGS } from "../i18n/translations";

export function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  return (
    <div data-testid="language-switcher" className="flex items-center gap-1.5">
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          title={l.label}
          aria-label={l.label}
          className={`h-6 w-8 overflow-hidden rounded-sm ring-1 transition-all duration-200 ${
            lang === l.code
              ? "ring-[#5B9DFF] opacity-100 scale-110"
              : "ring-white/20 opacity-45 hover:opacity-90"
          }`}
        >
          <img src={l.flag} alt={l.label} className="h-full w-full object-cover" />
        </button>
      ))}
    </div>
  );
}
